import * as React from "react";
import { Button, Grid, Typography, Link as A, Link } from "@mui/material";
import { AppBody } from "../AppBody";
import Breadcrumbs from "../../containers/Breadcrumbs";
import { appHeaderTitle } from "../../common/services/Utilities";
import HelpButton from "../HelpContent/HelpButton";
import makeStyles from "@mui/styles/makeStyles";
import { ReactComponent as APIDocumentation } from "../../common/assets/images/API_icon_API_static.svg";
import { ReactComponent as API101 } from "../../common/assets/images/API_icon_API101_static.svg";
import { ReactComponent as API101Focused } from "../../common/assets/images/API_icon_API101_focus.svg";
import { ReactComponent as BulkDataDownload } from "../../common/assets/images/API_icon_Bulk_static.svg";
import { ReactComponent as BulkDataDownloadFocused } from "../../common/assets/images/API_icon_Bulk_focus.svg";
import { ReactComponent as APIDocumentationFocused } from "../../common/assets/images/API_icon_API_focus.svg";
import { useInitialPageLoad } from "../../hooks/useInitialPageLoad";
import { AppUrl } from "../../config";
import CloudFoundryBanner from "../../containers/CloudFoundryBanner";
import { useHistory } from "react-router-dom";

const useStyle = makeStyles(theme => ({
  button: {
    "display": "block",
    "height": 330,
    "margin": "0 auto",
    "&:hover, &.Mui-focusVisible": {
      "backgroundColor": "transparent",
      "& .Rectangle-ManageSPG-Copy, & #Path-3": {
        stroke: "#ffffff",
        fill: theme.palette.primary.main,
      },
      "& #Group-4, & #arrow": { fill: "#ffffff" },
      "& #Group-6, & #Rectangle-ManageSPG": {
        fill: "#ffffff",
      },
    },
  },
}));

export default function BulkDataApi() {
  const classes = useStyle();
  const history = useHistory();
  const [focusBulkData, setFocusBulkData] = React.useState(false);
  const [focusAPIDocs, setFocusAPIDocs] = React.useState(false);
  const [focusAPI101, setFocusAPI101] = React.useState(false);

  const BulkDataDownloadSVG =
    focusBulkData === true ? <BulkDataDownloadFocused /> : <BulkDataDownload />;
  const APIDocumentationSVG =
    focusAPIDocs === true ? <APIDocumentationFocused /> : <APIDocumentation />;
  const API101SVG = focusAPI101 === true ? <API101Focused /> : <API101 />;
  useInitialPageLoad("bulkData");

  const introParagraph = (
    <>
      {appHeaderTitle("bulkData")}
      <Typography variant="body2" id="bulk-data-api-description">
        BankFind Suite enables users to search, filter, and download bank data
        using our API, offering precise, customized control over the results.
      </Typography>
      <Typography variant="body2">
        Alternatively, some users prefer to request larger bulk datasets for
        more flexible offline processing. For this purpose, we provide a bulk
        data generator, also powered by our API, though it offers fewer
        customization options.
      </Typography>
      <Typography variant="body2" id="bulk-data-api-link">
        Provide{" "}
        <Link
          href={
            "https://ask.fdic.gov/fdicinformationandsupportcenter/s/fdicdirform?app=FinRegData"
          }
        >
          feedback or submit a question
        </Link>{" "}
        about this page.
      </Typography>
    </>
  );

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={11}>
          <Breadcrumbs currentPageBreadCrumbTitle="Bulk Data and API" />
        </Grid>
        <Grid item xs={1}>
          <HelpButton />
        </Grid>
      </Grid>
      <CloudFoundryBanner />
      <AppBody introText={introParagraph}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <Button
              id="bulkData"
              className={classes.button}
              onMouseEnter={() => setFocusBulkData(true)}
              onMouseLeave={() => setFocusBulkData(false)}
              onClick={() =>
                history.push({
                  pathname: `${AppUrl("BulkData")}/bulkDataDownload`,
                })
              }
            >
              {BulkDataDownloadSVG}
              <Typography style={{ paddingTop: 16 }} variant="h2">
                Bulk Data Download
              </Typography>
            </Button>
          </Grid>

          <Grid item xs={12} md={3}>
            <Button
              id="apiDocs"
              className={classes.button}
              onMouseEnter={() => setFocusAPIDocs(true)}
              onMouseLeave={() => setFocusAPIDocs(false)}
            >
              <A href={AppUrl("API")}>{APIDocumentationSVG}</A>
              <Typography
                style={{ textDecoration: "none", paddingTop: 16 }}
                variant="h2"
              >
                API Documentation
              </Typography>
            </Button>
          </Grid>
          <Grid item xs={12} md={3}>
            <Button
              id="api101"
              className={classes.button}
              onMouseEnter={() => setFocusAPI101(true)}
              onMouseLeave={() => setFocusAPI101(false)}
              onClick={() => history.push(`${AppUrl("BulkData")}/api101`)}
            >
              {API101SVG}
              <Typography style={{ paddingTop: 16 }} variant="h2">
                API 101
              </Typography>
            </Button>
          </Grid>
        </Grid>
      </AppBody>
    </>
  );
}
